// // // // // // // // import React from "react";

// // // // // // // // import {
// // // // // // // //   Document,
// // // // // // // //   Page,
// // // // // // // //   pdfjs,
// // // // // // // // } from "react-pdf";

// // // // // // // // import "react-pdf/dist/Page/AnnotationLayer.css";
// // // // // // // // import "react-pdf/dist/Page/TextLayer.css";

// // // // // // // // pdfjs.GlobalWorkerOptions.workerSrc =
// // // // // // // //   `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

// // // // // // // // type Props = {
// // // // // // // //   file: string;
// // // // // // // // };

// // // // // // // // const PdfViewer = ({
// // // // // // // //   file,
// // // // // // // // }: Props) => {

// // // // // // // //   return (
// // // // // // // //     <div
// // // // // // // //       onContextMenu={(e) =>
// // // // // // // //         e.preventDefault()
// // // // // // // //       }
// // // // // // // //       style={{
// // // // // // // //         width: "100%",
// // // // // // // //         height: "100%",
// // // // // // // //         overflow: "auto",
// // // // // // // //         background: "#fff",
// // // // // // // //       }}
// // // // // // // //     >
// // // // // // // //       <Document
// // // // // // // //         file={file}
// // // // // // // //         loading="Loading PDF..."
// // // // // // // //       >
// // // // // // // //         <Page
// // // // // // // //           pageNumber={1}
// // // // // // // //           width={1100}
// // // // // // // //         />
// // // // // // // //       </Document>
// // // // // // // //     </div>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // export default PdfViewer;



// // // // // // // import React from "react";

// // // // // // // import {
// // // // // // //   Document,
// // // // // // //   Page,
// // // // // // //   pdfjs,
// // // // // // // } from "react-pdf";

// // // // // // // import "react-pdf/dist/Page/AnnotationLayer.css";
// // // // // // // import "react-pdf/dist/Page/TextLayer.css";

// // // // // // // pdfjs.GlobalWorkerOptions.workerSrc =
// // // // // // //   `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`;

// // // // // // // type Props = {
// // // // // // //   file: string;
// // // // // // // };

// // // // // // // const PdfViewer = ({
// // // // // // //   file,
// // // // // // // }: Props) => {

// // // // // // //   console.log("PDF URL:", file);

// // // // // // //   return (
// // // // // // //     <div
// // // // // // //       onContextMenu={(e) =>
// // // // // // //         e.preventDefault()
// // // // // // //       }
// // // // // // //       style={{
// // // // // // //         width: "100%",
// // // // // // //         height: "100%",
// // // // // // //         overflow: "auto",
// // // // // // //         background: "#fff",
// // // // // // //       }}
// // // // // // //     >
// // // // // // //       <Document
// // // // // // //         file={file}
// // // // // // //         loading="Loading PDF..."
// // // // // // //         error="Failed to load PDF file."
// // // // // // //       >
// // // // // // //         <Page
// // // // // // //           pageNumber={1}
// // // // // // //           width={1100}
// // // // // // //         />
// // // // // // //       </Document>
// // // // // // //     </div>
// // // // // // //   );
  
// // // // // // // };


// // // // // // // export default PdfViewer;



// // // // // import React, {
// // // // //   useEffect,
// // // // //   useState,
// // // // // } from "react";

// // // // // import {
// // // // //   Document,
// // // // //   Page,
// // // // //   pdfjs,
// // // // // } from "react-pdf";

// // // // // import "react-pdf/dist/Page/AnnotationLayer.css";
// // // // // import "react-pdf/dist/Page/TextLayer.css";

// // // // // pdfjs.GlobalWorkerOptions.workerSrc =
// // // // //   `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`;

// // // // // type Props = {
// // // // //   file: string;
// // // // // };

// // // // // const PdfViewer = ({
// // // // //   file,
// // // // // }: Props) => {

// // // // //   const [pdfBlob, setPdfBlob] =
// // // // //     useState<string>("");

// // // // //   useEffect(() => {

// // // // //     const loadPdf = async () => {

// // // // //       try {

// // // // //         const response =
// // // // //           await fetch(file);

// // // // //         const blob =
// // // // //           await response.blob();

// // // // //         const blobUrl =
// // // // //           URL.createObjectURL(blob);

// // // // //         setPdfBlob(blobUrl);

// // // // //       } catch (error) {

// // // // //         console.error(
// // // // //           "PDF Load Error:",
// // // // //           error
// // // // //         );

// // // // //       }
// // // // //     };

// // // // //     loadPdf();

// // // // //   }, [file]);

// // // // //   return (
// // // // //     <div
// // // // //       onContextMenu={(e) =>
// // // // //         e.preventDefault()
// // // // //       }
// // // // //       style={{
// // // // //         width: "100%",
// // // // //         height: "100%",
// // // // //         overflow: "auto",
// // // // //         background: "#fff",
// // // // //       }}
// // // // //     >
// // // // //       {pdfBlob && (

// // // // //         <Document
// // // // //           file={pdfBlob}
// // // // //           loading="Loading PDF..."
// // // // //           error="Failed to load PDF file."
// // // // //         >
// // // // //           <Page
// // // // //             pageNumber={1}
// // // // //             width={1100}
// // // // //           />
// // // // //         </Document>

// // // // //       )}
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // export default PdfViewer;




// // // // import React, {
// // // //   useEffect,
// // // //   useState,
// // // // } from "react";

// // // // import {
// // // //   Document,
// // // //   Page,
// // // //   pdfjs,
// // // // } from "react-pdf";

// // // // import "react-pdf/dist/Page/AnnotationLayer.css";
// // // // import "react-pdf/dist/Page/TextLayer.css";

// // // // pdfjs.GlobalWorkerOptions.workerSrc =
// // // //   `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`;

// // // // type Props = {
// // // //   file: string;
// // // // };

// // // // const PdfViewer = ({
// // // //   file,
// // // // }: Props) => {

// // // //   const [pdfBlob, setPdfBlob] =
// // // //     useState<string>("");

// // // //   const [numPages, setNumPages] =
// // // //     useState(0);

// // // //   const [pageWidth, setPageWidth] =
// // // //     useState(1000);

// // // //   useEffect(() => {

// // // //     const updateWidth = () => {

// // // //       const availableWidth =
// // // //         window.innerWidth - 420;

// // // //       setPageWidth(
// // // //         Math.min(
// // // //           Math.max(
// // // //             availableWidth,
// // // //             700
// // // //           ),
// // // //           1100
// // // //         )
// // // //       );
// // // //     };

// // // //     updateWidth();

// // // //     window.addEventListener(
// // // //       "resize",
// // // //       updateWidth
// // // //     );

// // // //     return () =>
// // // //       window.removeEventListener(
// // // //         "resize",
// // // //         updateWidth
// // // //       );

// // // //   }, []);

// // // //   useEffect(() => {

// // // //     const loadPdf = async () => {

// // // //       try {

// // // //         const response =
// // // //           await fetch(file);

// // // //         const blob =
// // // //           await response.blob();

// // // //         const blobUrl =
// // // //           URL.createObjectURL(blob);

// // // //         setPdfBlob(blobUrl);

// // // //       } catch (error) {

// // // //         console.error(
// // // //           "PDF Load Error:",
// // // //           error
// // // //         );

// // // //       }
// // // //     };

// // // //     loadPdf();

// // // //   }, [file]);

// // // //   return (
// // // //     <div
// // // //       onContextMenu={(e) =>
// // // //         e.preventDefault()
// // // //       }
// // // //       style={{
// // // //         width: "100%",
// // // //         height: "100%",
// // // //         overflowY: "auto",
// // // //         overflowX: "hidden",
// // // //         background: "#fff",

// // // //         display: "flex",
// // // //         justifyContent: "center",
// // // //         alignItems: "flex-start",

// // // //         padding: 20,
// // // //         boxSizing: "border-box",
// // // //       }}
// // // //     >
// // // //       {pdfBlob && (

// // // //         <Document
// // // //           file={pdfBlob}
// // // //           loading="Loading PDF..."
// // // //           error="Failed to load PDF"
// // // //           onLoadSuccess={({
// // // //             numPages,
// // // //           }) =>
// // // //             setNumPages(
// // // //               numPages
// // // //             )
// // // //           }
// // // //         >

// // // //           {Array.from(
// // // //             new Array(
// // // //               numPages
// // // //             ),
// // // //             (_, index) => (
// // // //               <div
// // // //                 key={index}
// // // //                 style={{
// // // //                   marginBottom:
// // // //                     20,
// // // //                 }}
// // // //               >
// // // //                 <Page
// // // //                   pageNumber={
// // // //                     index + 1
// // // //                   }
// // // //                   width={
// // // //                     pageWidth
// // // //                   }
// // // //                 />
// // // //               </div>
// // // //             )
// // // //           )}

// // // //         </Document>

// // // //       )}
// // // //     </div>
// // // //   );
// // // // };

// // // // export default PdfViewer;




// // // import React, {
// // //   useEffect,
// // //   useState,
// // //   useRef,
// // // } from "react";

// // // import {
// // //   Document,
// // //   Page,
// // //   pdfjs,
// // // } from "react-pdf";

// // // import "react-pdf/dist/Page/AnnotationLayer.css";
// // // import "react-pdf/dist/Page/TextLayer.css";

// // // pdfjs.GlobalWorkerOptions.workerSrc =
// // //   `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`;

// // // type Props = {
// // //   file: string;
// // // };

// // // const PdfViewer = ({
// // //   file,
// // // }: Props) => {

// // //   const [pdfBlob, setPdfBlob] =
// // //     useState<string>("");

// // //   const [numPages, setNumPages] =
// // //     useState(0);

// // //   const [pageWidth, setPageWidth] =
// // //     useState(900);

// // //   const containerRef =
// // //     useRef<HTMLDivElement>(null);

// // //   useEffect(() => {

// // //     const calculateWidth =
// // //       () => {

// // //         if (
// // //           containerRef.current
// // //         ) {

// // //           const width =
// // //             containerRef.current
// // //               .offsetWidth;

// // //           setPageWidth(
// // //             Math.max(
// // //               600,
// // //               Math.min(
// // //                 width - 40,
// // //                 1200
// // //               )
// // //             )
// // //           );
// // //         }
// // //       };

// // //     calculateWidth();

// // //     window.addEventListener(
// // //       "resize",
// // //       calculateWidth
// // //     );

// // //     return () => {

// // //       window.removeEventListener(
// // //         "resize",
// // //         calculateWidth
// // //       );

// // //     };

// // //   }, []);

// // //   useEffect(() => {

// // //     const loadPdf =
// // //       async () => {

// // //         try {

// // //           const response =
// // //             await fetch(file);

// // //           const blob =
// // //             await response.blob();

// // //           const blobUrl =
// // //             URL.createObjectURL(
// // //               blob
// // //             );

// // //           setPdfBlob(
// // //             blobUrl
// // //           );

// // //         } catch (error) {

// // //           console.error(
// // //             "PDF Load Error:",
// // //             error
// // //           );

// // //         }
// // //       };

// // //     loadPdf();

// // //   }, [file]);

// // //   return (

// // //     <div
// // //       ref={containerRef}
// // //       onContextMenu={(e) =>
// // //         e.preventDefault()
// // //       }
// // //       style={{
// // //         width: "100%",
// // //         height: "100%",
// // //         overflowY: "auto",
// // //         overflowX: "hidden",
// // //         background: "#f8f8f8",
// // //         padding: "20px",
// // //         boxSizing:
// // //           "border-box",
// // //         display: "flex",
// // //         justifyContent:
// // //           "center",
// // //       }}
// // //     >

// // //       {pdfBlob && (

// // //         <Document
// // //           file={pdfBlob}
// // //           loading="Loading PDF..."
// // //           error="Failed to load PDF"
// // //           onLoadSuccess={({
// // //             numPages,
// // //           }) =>
// // //             setNumPages(
// // //               numPages
// // //             )
// // //           }
// // //         >

// // //           <div
// // //             style={{
// // //               display: "flex",
// // //               flexDirection:
// // //                 "column",
// // //               alignItems:
// // //                 "center",
// // //               width: "100%",
// // //             }}
// // //           >

// // //             {Array.from(
// // //               {
// // //                 length:
// // //                   numPages,
// // //               }
// // //             ).map(
// // //               (_, index) => (

// // //                 <div
// // //                   key={index}
// // //                   style={{
// // //                     marginBottom:
// // //                       24,
// // //                     boxShadow:
// // //                       "0 2px 10px rgba(0,0,0,0.15)",
// // //                     background:
// // //                       "#fff",
// // //                   }}
// // //                 >

// // //                   <Page
// // //                     pageNumber={
// // //                       index + 1
// // //                     }
// // //                     width={
// // //                       pageWidth
// // //                     }
// // //                     renderTextLayer={
// // //                       false
// // //                     }
// // //                     renderAnnotationLayer={
// // //                       false
// // //                     }
// // //                   />

// // //                 </div>

// // //               )
// // //             )}

// // //           </div>

// // //         </Document>

// // //       )}

// // //     </div>

// // //   );
// // // };

// // // export default PdfViewer;



// // import React, {
// //   useEffect,
// //   useState,
// //   useRef,
// // } from "react";

// // import {
// //   Document,
// //   Page,
// //   pdfjs,
// // } from "react-pdf";

// // import "react-pdf/dist/Page/AnnotationLayer.css";
// // import "react-pdf/dist/Page/TextLayer.css";

// // pdfjs.GlobalWorkerOptions.workerSrc =
// //   `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

// // type Props = {
// //   file: string;
// // };

// // const PdfViewer = ({
// //   file,
// // }: Props) => {
// //   const [pdfBlob, setPdfBlob] =
// //     useState<string>("");

// //   const [numPages, setNumPages] =
// //     useState(0);

// //   const [pageWidth, setPageWidth] =
// //     useState(900);

// //   const [loading, setLoading] =
// //     useState(false);

// //   const [error, setError] =
// //     useState("");

// //   const containerRef =
// //     useRef<HTMLDivElement>(null);

// //   useEffect(() => {
// //     const calculateWidth = () => {
// //       if (containerRef.current) {
// //         const width =
// //           containerRef.current.offsetWidth;

// //         setPageWidth(
// //           Math.max(
// //             600,
// //             Math.min(width - 40, 1200)
// //           )
// //         );
// //       }
// //     };

// //     calculateWidth();

// //     window.addEventListener(
// //       "resize",
// //       calculateWidth
// //     );

// //     return () => {
// //       window.removeEventListener(
// //         "resize",
// //         calculateWidth
// //       );
// //     };
// //   }, []);

// //   useEffect(() => {
// //     let objectUrl = "";

// //     const loadPdf = async () => {
// //       try {
// //         setLoading(true);
// //         setError("");
// //         setPdfBlob("");

// //         console.log(
// //           "Loading PDF URL:",
// //           file
// //         );

// //         const response =
// //           await fetch(file, {
// //             method: "GET",
// //           });

// //         console.log(
// //           "PDF STATUS:",
// //           response.status
// //         );

// //         console.log(
// //           "PDF CONTENT TYPE:",
// //           response.headers.get(
// //             "content-type"
// //           )
// //         );

// //         if (!response.ok) {
// //           throw new Error(
// //             `HTTP ${response.status}`
// //           );
// //         }

// //         const contentType =
// //           response.headers.get(
// //             "content-type"
// //           );

// //         if (
// //           contentType &&
// //           !contentType.includes(
// //             "application/pdf"
// //           )
// //         ) {
// //           throw new Error(
// //             `Invalid content type: ${contentType}`
// //           );
// //         }

// //         const blob =
// //           await response.blob();

// //         console.log(
// //           "PDF SIZE:",
// //           blob.size
// //         );

// //         objectUrl =
// //           URL.createObjectURL(blob);

// //         setPdfBlob(objectUrl);
// //       } catch (err: any) {
// //         console.error(
// //           "PDF FETCH ERROR:",
// //           err
// //         );

// //         setError(
// //           err?.message ||
// //             "Failed to load PDF"
// //         );
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     if (file) {
// //       loadPdf();
// //     }

// //     return () => {
// //       if (objectUrl) {
// //         URL.revokeObjectURL(
// //           objectUrl
// //         );
// //       }
// //     };
// //   }, [file]);

// //   return (
// //     <div
// //       ref={containerRef}
// //       onContextMenu={(e) =>
// //         e.preventDefault()
// //       }
// //       style={{
// //         width: "100%",
// //         height: "100%",
// //         overflowY: "auto",
// //         overflowX: "hidden",
// //         background: "#f8f8f8",
// //         padding: "20px",
// //         boxSizing: "border-box",
// //         display: "flex",
// //         justifyContent: "center",
// //       }}
// //     >
// //       {loading && (
// //         <div
// //           style={{
// //             padding: 40,
// //             fontSize: 18,
// //           }}
// //         >
// //           Loading PDF...
// //         </div>
// //       )}

// //       {error && (
// //         <div
// //           style={{
// //             padding: 40,
// //             color: "red",
// //             fontWeight: 600,
// //           }}
// //         >
// //           Error: {error}
// //         </div>
// //       )}

// //       {!loading &&
// //         !error &&
// //         pdfBlob && (
// //           <Document
// //             file={pdfBlob}
// //             loading="Loading PDF..."
// //             error="Failed to load PDF"
// //             onLoadSuccess={({
// //               numPages,
// //             }) => {
// //               console.log(
// //                 "PDF Loaded Successfully"
// //               );

// //               console.log(
// //                 "Pages:",
// //                 numPages
// //               );

// //               setNumPages(
// //                 numPages
// //               );
// //             }}
// //             onLoadError={(error) => {
// //               console.error(
// //                 "PDFJS LOAD ERROR:",
// //                 error
// //               );

// //               setError(
// //                 String(error)
// //               );
// //             }}
// //             onSourceError={(error) => {
// //               console.error(
// //                 "PDF SOURCE ERROR:",
// //                 error
// //               );

// //               setError(
// //                 String(error)
// //               );
// //             }}
// //           >
// //             <div
// //               style={{
// //                 display: "flex",
// //                 flexDirection:
// //                   "column",
// //                 alignItems:
// //                   "center",
// //                 width: "100%",
// //               }}
// //             >
// //               {Array.from(
// //                 {
// //                   length: numPages,
// //                 },
// //                 (_, index) => (
// //                   <div
// //                     key={index}
// //                     style={{
// //                       marginBottom: 24,
// //                       background:
// //                         "#ffffff",
// //                       boxShadow:
// //                         "0 2px 10px rgba(0,0,0,0.15)",
// //                     }}
// //                   >
// //                     <Page
// //                       pageNumber={
// //                         index + 1
// //                       }
// //                       width={
// //                         pageWidth
// //                       }
// //                       renderTextLayer={
// //                         false
// //                       }
// //                       renderAnnotationLayer={
// //                         false
// //                       }
// //                     />
// //                   </div>
// //                 )
// //               )}
// //             </div>
// //           </Document>
// //         )}
// //     </div>
// //   );
// // };

// // export default PdfViewer;




// import React, {
//   useEffect,
//   useState,
//   useRef,
// } from "react";

// type Props = {
//   file: string;
// };

// const PdfViewer = ({ file }: Props) => {
//   const [pdfBlob, setPdfBlob] = useState<string>("");
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const containerRef = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     let objectUrl = "";
//     let isMounted = true;

//     const loadPdf = async () => {
//       try {
//         setLoading(true);
//         setError("");
//         setPdfBlob("");

//         console.log("Loading PDF URL:", file);

//         const response = await fetch(file, {
//           method: "GET",
//         });

//         console.log("PDF STATUS:", response.status);
//         console.log("PDF CONTENT TYPE:", response.headers.get("content-type"));

//         if (!response.ok) {
//           throw new Error(`HTTP ${response.status}`);
//         }

//         const contentType = response.headers.get("content-type");
//         if (contentType && !contentType.includes("application/pdf")) {
//           throw new Error(`Invalid content type: ${contentType}`);
//         }

//         const blob = await response.blob();
//         console.log("PDF SIZE:", blob.size);

//         if (blob.size < 100) {
//           throw new Error("Received empty or invalid PDF blob");
//         }

//         objectUrl = URL.createObjectURL(blob);

//         if (isMounted) {
//           setPdfBlob(objectUrl);
//         }
//       } catch (err: any) {
//         console.error("PDF FETCH ERROR:", err);
//         if (isMounted) {
//           setError(err?.message || "Failed to load PDF");
//         }
//       } finally {
//         if (isMounted) {
//           setLoading(false);
//         }
//       }
//     };

//     if (file) {
//       loadPdf();
//     }

//     return () => {
//       isMounted = false;
//       if (objectUrl) {
//         URL.revokeObjectURL(objectUrl);
//       }
//     };
//   }, [file]);

//   return (
//     <div
//       ref={containerRef}
//       onContextMenu={(e) => e.preventDefault()}
//       style={{
//         width: "100%",
//         height: "100%",
//         overflowY: "auto",
//         overflowX: "hidden",
//         background: "#f8f8f8",
//         padding: "20px",
//         boxSizing: "border-box",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//       }}
//     >
//       {loading && (
//         <div style={{ padding: 40, fontSize: 18 }}>
//           Loading PDF...
//         </div>
//       )}

//       {error && (
//         <div style={{ padding: 40, color: "red", fontWeight: 600 }}>
//           Error: {error}
//         </div>
//       )}

//       {!loading && !error && pdfBlob && (
//         <iframe
//           src={`${pdfBlob}#toolbar=0`}
//           style={{
//             width: "100%",
//             height: "100%",
//             border: "none",
//             minHeight: "750px",
//             background: "#ffffff",
//             boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
//           }}
//           title="Section Report Preview"
//         />
//       )}
//     </div>
//   );
// };

// export default PdfViewer;


import React, { useEffect, useState } from "react";

type Props = {
  file: string;
};

const PdfViewer = ({ file }: Props) => {
  const [pdfBlob, setPdfBlob] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let objectUrl = "";
    let isMounted = true;

    const loadPdf = async () => {
      try {
        setLoading(true);
        setError("");
        setPdfBlob("");

        const response = await fetch(file, {
          method: "GET",
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const contentType = response.headers.get("content-type");

        if (
          contentType &&
          !contentType.toLowerCase().includes("application/pdf")
        ) {
          throw new Error(`Invalid content type: ${contentType}`);
        }

        const blob = await response.blob();

        if (blob.size < 100) {
          throw new Error("Received empty or invalid PDF blob");
        }

        objectUrl = URL.createObjectURL(blob);

        if (isMounted) {
          setPdfBlob(objectUrl);
        }
      } catch (err: any) {
        console.error("PDF FETCH ERROR:", err);

        if (isMounted) {
          setError(err?.message || "Failed to load PDF");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    if (file) {
      loadPdf();
    }

    return () => {
      isMounted = false;

      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [file]);

  return (
    <div
      onContextMenu={(e) => e.preventDefault()}
      style={{
        width: "100%",
        height: "100%",
        minHeight: 0,
        overflow: "hidden",
        background: "#f1f3f5",
        padding: "12px",
        boxSizing: "border-box",
      }}
    >
      {loading && (
        <div
          style={{
            width: "100%",
            height: "100%",
            minHeight: 400,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 16,
            color: "#475569",
          }}
        >
          Loading PDF...
        </div>
      )}

      {error && (
        <div
          style={{
            padding: 30,
            color: "#dc2626",
            fontWeight: 600,
          }}
        >
          Error: {error}
        </div>
      )}

      {!loading && !error && pdfBlob && (
        <iframe
          src={`${pdfBlob}#toolbar=0&navpanes=0&scrollbar=1&view=FitH&zoom=page-width&page=1`}
          style={{
            display: "block",
            width: "100%",
            height: "100%",
            minHeight: 0,
            border: "none",
            background: "#ffffff",
            boxShadow: "0 2px 10px rgba(0,0,0,0.12)",
          }}
          title="Section Report Preview"
        />
      )}
    </div>
  );
};

export default PdfViewer;